module.exports = __webpack_public_path__ + "media/images/flags/pl-55073d98d77a5b6ce0c1cd3e76d22b2a.svg";